import { Mobile, PC, Tablet, Notebook } from "../../views/ReactiveMode"
import YoutubeSlider from "../component/YoutubeSlider"

function ImageBackgroundYoutube(props) {
    return (
        <>
            <PC>
                <section className="pc-image-background">
                    <div className="background">
                        <div className="layout" style={{ height: props?.height }}>
                            <YoutubeSlider youtubeListId="PLcGden08y5zbbwUqGPiZWpkhw01chku--" limit="6" />
                            <div></div>
                            <YoutubeSlider youtubeListId="PLNE47-TR5TeyeAIxsQWHwfiBFRu7dxWfC" limit="6" />
                        </div>
                    </div>
                </section>
            </PC>

            <Notebook>
                <section className="pc-image-background">
                    <div className="background">
                        <div className="layout" style={{ height: props?.height }}>
                            <YoutubeSlider youtubeListId="PLcGden08y5zbbwUqGPiZWpkhw01chku--" limit="6" />
                            <div></div>
                            <YoutubeSlider youtubeListId="PLNE47-TR5TeyeAIxsQWHwfiBFRu7dxWfC" limit="6" />
                        </div>
                    </div>
                </section>
            </Notebook>

            <Tablet>
                <section className="mobile-image-background">
                    <div className="background">
                        <div className="layout" style={{ height: props?.height }}>
                            <YoutubeSlider youtubeListId="PLcGden08y5zbbwUqGPiZWpkhw01chku--" limit="6" />
                            <div></div>
                            <YoutubeSlider youtubeListId="PLNE47-TR5TeyeAIxsQWHwfiBFRu7dxWfC" limit="6" />
                        </div>
                    </div>
                </section>
            </Tablet>

            <Mobile>
                <section className="mobile-image-background">
                    <div className="background">
                        <div className="layout" style={{ height: props?.height }}>
                            <YoutubeSlider youtubeListId="PLcGden08y5zbbwUqGPiZWpkhw01chku--" limit="6" />
                            <div></div>
                            <YoutubeSlider youtubeListId="PLNE47-TR5TeyeAIxsQWHwfiBFRu7dxWfC" limit="6" />
                        </div>
                    </div>
                </section>
            </Mobile>
        </>
    )
}

export default ImageBackgroundYoutube
